import { useEffect, useState } from 'react'
import { leases as leaseApi } from '@/api/endpoints'
import { pastTags } from '@/domain/lease'
import { useSession } from '@/hooks/useSession'

/**
 * 내가 전에 쓴 태그(`pastTags`). 태그 칸이 열릴 때 내 임대(`user` 가 나)를 한 번 읽는다 — 칸을 여는 화면마다 목록이 다르게 손에 있어
 * (사용자는 임대 하나, 관리자는 목록의 한 쪽) 같은 제안이 화면마다 다르게 서지 않게 한 자리에서 읽는다. 읽지 못하면 제안이 없을 뿐이다.
 * 남의 임대는 서버가 싣지 않는다 — 최고 관리자도 자기 임대만 받는다.
 */
export function usePastTags(current: readonly string[]): string[] {
  const me = useSession()
  const [mine, setMine] = useState<{ tags: string[] }[]>([])
  useEffect(() => {
    let alive = true
    leaseApi
      .list({ user: me.id })
      .then((all) => {
        if (alive) setMine(all)
      })
      .catch(() => undefined)
    return () => {
      alive = false
    }
  }, [me.id])
  return pastTags(mine, current)
}
